import TYPES from '../actions/types';
import paginationDefault from '../../../constants/pagination';

const INITIAL_STATE = {
  reference: null,
  object: null,
  beneficiary: null,
  valueInit: null,
  valueEnd: null,
  requester: null,
  region: null,
  stageId: null,
  secretaryId: null,
  resourceOrigin: null,
  year: null,

  page: paginationDefault.page,
  limit: paginationDefault.limit,
}

export default function(state = INITIAL_STATE, action) {
  const acType = TYPES[action.type] ?? action.type;

  switch(acType) {
    case TYPES.changeFormSearchField:
      return {
        ...state,
        [action.payload.fieldName]: action.payload.value,
      }

    case TYPES.setDefaultPage:
      return {
        ...state,
        page: paginationDefault.page,
        limit: paginationDefault.limit,
      };

    case TYPES.clearFormSearchFields:
      return {
        ...state,
        reference: null,
        object: null,
        beneficiary: null,
        valueInit: null,
        valueEnd: null,
        requester: null,
        region: null,
        stageId: null,
        secretaryId: null,
        resourceOrigin: null,
        year: null,
      }

    case TYPES.paginationFormSearch:
      return { ...state, page: action.payload };

    default:
      return state;
  }
}
